import { FC, useState } from 'react';
import { Button, Modal, RadioChangeEvent, Select } from 'antd';
import AddFittingType from './AddFittingType';
import FittingTypeList from './FittingTypeList';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadFittingTypes, loadMeasureUnit } from './fittingTypeSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { isUserAdmin } from '../../services/authenticationService';
import { AppState } from '../../redux/store/rootReducer';
import { loadFittingSizes } from '../fittingSize/fittingSizeSlice';
import { loadBodySizes } from '../bodySize/bodySizeSlice';
import { loadCategory } from '../category/categorySlice';

const FittingTypes: FC = () => {
  const dispatch = useDispatch();
  const { isModalOpen, setModelChange, contextHolder, editUser, setEditUser, setList } = React.useContext(CommonContext) as CommonContextType;
  const FittingTypes = useSelector(
    (state: AppState) => state.FittingTypes
  );
  const [selected, setSelected] = useState<any>('All')

  React.useEffect(() => {
    dispatch(loadFittingTypes());
    dispatch(loadFittingSizes());
    dispatch(loadBodySizes());
    dispatch(loadMeasureUnit());
    dispatch(loadCategory())
  }, [dispatch]);

  React.useEffect(() => {
    setSelected("All")
  }, [FittingTypes]);

  const showModal = () => {
    setModelChange(true);
  };
  const handleCancel = () => {
    setEditUser(null)
    setModelChange(false);
  };

  /* const onChangeSizeType = (value: string) => {
    setSelected(value)
    setList(toggleFittingTypes(value))
  };

  const toggleFittingTypes = (data: string): any => () => {
    if (data.toLowerCase() !== 'all') {
      // return FittingTypes.FittingType.filter(item => item.size_type?.toLowerCase() === data.toLowerCase());
    } else {
      return FittingTypes.FittingType;
    }
  } */

  return (
    <div className='padding'>
      {contextHolder}
      <h2>Connection Type List
        {/* <Select
          defaultValue="All"
          style={{
            width: 120,
            marginLeft: 15,
          }}
          onChange={onChangeSizeType}
          value={selected}
          options={[
            {
              value: 'All',
              label: 'All',
            },
            {
              value: 'Inch',
              label: 'Inch',
            },
            {
              value: 'Metric',
              label: 'Metric',
            },
          ]}
        /> */}
        <button className='top-button' onClick={showModal}>Create</button>
      </h2>
      <br></br>
      <FittingTypeList />
      <Modal title={editUser?.id ? 'Edit Type' : 'Create Type'} open={isModalOpen} onCancel={handleCancel} maskClosable={false} footer={null} width={700}>
        <AddFittingType />
      </Modal>
    </div>
  );
};

export default FittingTypes;